import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

// material core
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

// material icon
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

// configs
import { USER_ROLE } from 'configs';

// actions
import { login } from 'actions/auth.action';
import { Grid } from '@material-ui/core';
import { errorSelector, userSelector } from 'selectors/auth.selector';
import axios from 'axios';
import { API_URLS } from 'utils/apiUtils';
import authService from 'services/authService';

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 15,
    flex: 1,
    paddingLeft: '10rem',
    paddingRight: '10rem',
    justifyContent: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },

  logoText: {
    color: '#4E82EA',
  },

  flexSpaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  leftSide: {
    background: 'linear-gradient(180deg, #4E82EA 0%, #245BCA 100%)',
    flex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function UpdatePassword() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setcPassword] = useState('');
  const [role, setRole] = useState('ADMIN');
  const [error, setError] = useState('');
  const loginError = useSelector(errorSelector);
  const user = useSelector(userSelector);
  const token = authService.getAccessToken();

  const _onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // dispatch(login(name, role, history));
    // dispatch(login(name, password, history));
    if (cpassword == password) {
      const res = await axios.post(`${API_URLS.UPDATE_PASSWORD}`, { password: password }, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });

      if (res.status == 200) {
        window.location.href = "/";
      }

    } else {
      setError("Password do not match!");
    }



  };

  return (
    <div style={{ display: 'flex', height: '100vh' }}>
      {/* <CssBaseline /> */}
      <div className={classes.leftSide}>
        <img style={{ objectFit: 'contain' }} src="/assets/images/loginlogo.jpg" alt="govt. of india" />
      </div>
      <Container component="main" maxWidth="md" className={classes.paper}>
        {/* <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar> */}
        <Grid container className={classes.flexSpaceBetween}>
          <Grid item md={6}>
            <img width={200} src="/assets/images/logo2.png" alt="Accessible india logo" />
          </Grid>
          {/* <Grid item md={6}>
         
          </Grid> */}
          <Grid item md={6}>
            <img width={200} src="/assets/images/logo1.png" alt="swavlamban" />
          </Grid>
        </Grid>

        <Typography component="h2" variant="h2" className={classes.logoText}>
          Update Temporary Password
        </Typography>
        <Typography component="h2" variant="body1">
          Welcome, {user}
        </Typography>
        <form className={classes.form} noValidate onSubmit={_onSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="password"
            label="Password"
            name="password"
            autoComplete="new-password"
            type="password"
            // autoFocus
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="cpassword"
            label="Confirm Password"
            name="email"
            autoComplete="new-password"
            type="password"
            // autoFocus
            value={cpassword}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setcPassword(e.target.value)}
          />
          {/* <br /> */}
          {/* <FormControl variant="outlined" fullWidth>
            <InputLabel id="demo-simple-select-outlined-label">Role</InputLabel>
            <Select
              fullWidth
              value={role}
              onChange={(e: React.ChangeEvent<{ value: unknown }>) => setRole(e.target.value as string)}
              label="Role"
            >
              <MenuItem value={USER_ROLE.ADMIN}>Admin</MenuItem>
              <MenuItem value={USER_ROLE.LEAD}>Lead</MenuItem>
              <MenuItem value={USER_ROLE.GUEST}>Guest</MenuItem>
            </Select>
          </FormControl> */}
          {error && <Typography style={{ color: 'red' }}>{error}</Typography>}
          <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
            Update Password
          </Button>
        </form>
      </Container>
    </div>
  );
}
